import { Map, List } from 'immutable'
import {
  CONTENT_TYPE_SERIES,
  CONTENT_TYPE_VIDEO,
} from 'services/content/content-types'
import {
  PRODUCT_TYPE_EPISODE,
  PRODUCT_TYPE_SEGMENT,
  PRODUCT_TYPE_SINGLE,
  PRODUCT_TYPE_EPISODIC,
  PRODUCT_TYPE_SEGMENTED,
} from 'services/content/product-types'

export default Map({
  [CONTENT_TYPE_SERIES]: List([
    Map({ label: 'Please select a product type', value: '' }),
    Map({ label: 'Episodic', value: PRODUCT_TYPE_EPISODIC }),
    Map({ label: 'Segmented', value: PRODUCT_TYPE_SEGMENTED }),
  ]),
  [CONTENT_TYPE_VIDEO]: List([
    Map({ label: 'Please select a product type', value: '' }),
    Map({ label: 'Episode', value: PRODUCT_TYPE_EPISODE }),
    Map({ label: 'Segment', value: PRODUCT_TYPE_SEGMENT }),
    Map({ label: 'Single', value: PRODUCT_TYPE_SINGLE }),
  ]),
})
